var map = {
	"./arrow.svg": "d358",
	"./arrow_dark.svg": "63e0",
	"./arrow_light.svg": "3479",
	"./brain.svg": "e18f",
	"./checkmark.svg": "6de9",
	"./clock.svg": "15fb",
	"./closed_arrow.svg": "2708",
	"./go_to_pdf.svg": "1efb",
	"./green-ic.svg": "1235",
	"./growth-ic.svg": "9064",
	"./likemind-ic.svg": "a13f",
	"./people.svg": "e159",
	"./pole-img.svg": "e6a4",
	"./rocket.svg": "1e6d",
	"./selected.svg": "6275",
	"./wfh-ic.svg": "d727"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0acf";